import * as React from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { ILoginForm } from './types';
import KfLogo from '../../../Assets/kflogo_dark.png';
import { Stack } from '@mui/material';
import { ConfirmLogin } from '../../../App/Packages/ConfirmLogin';

const styles = (theme: any) => ({
    card: {
        top: '10vh',
        // position: 'relative' as 'relative',
        background: '#FFFFFF',
        boxShadow: '0px 3px 12px #00000012',
        borderRadius: '20px',
        padding: '80px',
        [theme.breakpoints.down('lg')]: {
            padding: '47px 72px',
        },
        [theme.breakpoints.down('md')]: {
            padding: '47px 72px',
        },
        [theme.breakpoints.down('sm')]: {
            padding: '47px 72px',
        },
        [theme.breakpoints.down('xs')]: {
            marginTop: '20px',
            padding: '20px 32px',
        },
        textAlign: 'center' as 'center',
    },
    heading: {
        fonFamily: 'League Spartan',
        fontWeight: 500,
        fontSize: '32px',
        lineHeight: '38px',
        textTransform: 'uppercase' as 'uppercase',
        marginBotom: '56px',
        [theme.breakpoints.down('xs')]: {
            fontSize: '24px',
        },
    },
    field: {
        width: '100%',
        marginTop: '20px',
        borderRadius: '0px',
        '& div': {
            borderRadius: '0px',
        },
        '& input': {
            background: '#fff',
            color: '#000',
            borderRadius: '0px',
        },
    },
    submitBtnWrapper: {
        textAlign: 'center' as 'center',
    },
    submitBtn: {
        fontWeight: 500,
        background: '#EF0017',
        textTransform: 'none' as 'none',
        borderRadius: '24px',
        color: 'white',
        fontSize: '14px',
        lineHeight: '18px',
        padding: '12px 24px',
        width: '102px',
        boxSize: 'borderBox',
        height: '48px',
        [theme.breakpoints.down('xs')]: {
            height: '32px',
            padding: '8px 16px',
            width: '80px',
        },
        '&:disabled': {
            background: '#cccccc',
            color: '#666666',
        },
    },
    errors: {
        border: '3px solid red',
    },
    message: {
        padding: '10px 0px',
        textAlign: 'center' as 'center',
        fontSize: '14px',
        lineHeight: '18px',
        marginTop: '24px',
    },
    resetPassword: {
        padding: '10px 0px',
        textAlign: 'center' as 'center',
        fontSize: '14px',
        lineHeight: '18px',
    },
    link: {
        color: '#EF0017',
        paddingLeft: '4px',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    textField: {
        width: '100%',
        display: 'flex',
        aligItems: 'flex-start',
        flexDirection: 'column' as 'column',
        marginBottom: '40px',
        '&:last-child': {
            marginBottom: '0px',
        },
    },

    labelField: {
        fontSize: '14px',
        lineHeight: '20px',
        textAlign: 'left' as 'left',
        fontWeight: 500,
    },
    inputField: {
        border: 'none',
        borderBottom: '1px solid black',
        padding: '16px 4px',
        marginTop: '4px',
        background: 'white',
        outline: 'none',
    },
    inputFieldError: {
        border: 'none',
        borderBottom: '1px solid red',
        padding: '16px 4px',
        marginTop: '4px',
        background: 'white',
        outline: 'none',
    },
    formWrapper: {
        marginTop: '24px',
        padding: '0px 25px',
    },
    erroSpan: {
        textAlign: 'left' as 'left',
        color: 'red',
        fontSize: '12px',
    },
});

interface IProps {
    classes: any;
    onSubmit: (method: string) => void;
    onConfirm: (method: string) => void;
    onCancel: (method: string) => void;
    form: ILoginForm;
    onChange: (
        form: 'login' | 'register',
        field: string
    ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
    emailIsInvalid: (form: 'login' | 'register') => boolean;
    formIsDisabled: (form: 'login' | 'register') => boolean;
}

export const loginBox = ({
    classes,
    form,
    onChange,
    onSubmit,
    onConfirm,
    onCancel,
    emailIsInvalid,
    formIsDisabled,
}: IProps) => {
    return (
        <div className={classes.card}>
            <ConfirmLogin 
                open={form.errors.status === 402} 
                onConfirm={() => onConfirm('login')}
                onClose={() => onCancel('login')} />
            <div className={classes.heading}>
            <img src={KfLogo} width='420' style={{ marginTop: '-196px', marginBottom: '-136px' }} />
            </div>
            <form className={classes.formWrapper}>
                <div className={classes.textField}>
                    <div className={classes.labelField}>Email</div>
                    <input
                        type='email'
                        id='username'
                        onChange={onChange('login', 'username')}
                        value={form.username}
                        className={
                            form.errors.state || emailIsInvalid('login')
                                ? classes.inputFieldError
                                : classes.inputField
                        }
                        autoComplete='off'
                        placeholder='Email *'
                        required={true}
                    ></input>
                    <span className={classes.erroSpan}>
                        {emailIsInvalid('login')
                            ? 'Invalid email'
                            : form.errors.state
                            ? 'Incorrect email'
                            : null}
                    </span>
                </div>
                <div className={classes.textField}>
                    <div className={classes.labelField}>Password</div>
                    <input
                        type='password'
                        id='password'
                        onChange={onChange('login', 'password')}
                        value={form.password}
                        placeholder='Password *'
                        className={
                            form.errors.state
                                ? classes.inputFieldError
                                : classes.inputField
                        }
                        autoComplete='off'
                        required={true}
                    ></input>
                    <span className={classes.erroSpan}>
                        {form.errors.state ? 'Incorrect password' : ''}
                    </span>
                </div>

                <div className={classes.submitBtnWrapper}>
                    <Button
                        disabled={formIsDisabled('login')}
                        variant='contained'
                        color='primary'
                        onClick={() => onSubmit('login')}
                        className={classes.submitBtn}
                    >
                        Log In
                    </Button>
                </div>

                <div className={classes.message}>
                    <span>No account?</span>
                    <Link to='/register' className={classes.link}>
                        Register now
                    </Link>
                </div>
                <div className={classes.resetPassword}>
                    <Link to='/reset' className={classes.link}>
                        Reset Password
                    </Link>
                </div>
                {/* <TextField
                    className={classes.field}
                    required
                    id='username'
                    onChange={onChange('login', 'username')}
                    value={form.username}
                    placeholder='Email *'
                    error={form.errors.state || emailIsInvalid('login')}
                    helperText={
                        emailIsInvalid('login') ? 'Email is not valid' : ''
                    }
                    type='email'
                /> */}
                {/* <TextField
                    className={classes.field}
                    required
                    variant='outlined'
                    type='password'
                    id='password'
                    onChange={onChange('login', 'password')}
                    value={form.password}
                    placeholder='Password *'
                    error={form.errors.state}
                    helperText={form.errors.serverErrors}
                /> */}
            </form>
        </div>
    );
};

export const LoginBox = withStyles(styles)(loginBox);
